import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'integrasiService'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const presensiList = 'Kepegawaian/IntegrasiSimpegBkn/list/'
export const presensiListPresensi = 'Kepegawaian/IntegrasiSimpegBkn/listpresensi/'
export const presensiListNonPresensi = 'Kepegawaian/IntegrasiSimpegBkn/listnonpresensi/'
export const presensilistatasan = 'Kepegawaian/IntegrasiSimpegBkn/listatasan/'
export const presensiInactive = 'Kepegawaian/IntegrasiSimpegBkn/inactive/'
export const presensiActive = 'Kepegawaian/IntegrasiSimpegBkn/active/'
export const presensiDetail = 'Kepegawaian/IntegrasiSimpegBkn/detail/'
export const bknServiceIdentitas = 'Kepegawaian/IntegrasiSimpegBkn/bknServiceIdentitas/'
export const bknServiceJabatan = 'Kepegawaian/IntegrasiSimpegBkn/bknServiceJabatan/'

export const bknServiceSendJabatan = 'Kepegawaian/IntegrasiSimpegBkn/bknServiceSendJabatan/'
export const bknServiceTakeJabatan = 'Kepegawaian/IntegrasiSimpegBkn/bknServiceTakeJabatan/'
export const bknServiceDownloadFile = 'Kepegawaian/IntegrasiSimpegBkn/bknServiceDownloadFile/'

export const masterEmployeeStatus = 'Kepegawaian/IntegrasiSimpegBkn/employeestatus/'
export const masterWorkUnit = 'Master/WorkUnit/list/'
export const presensiexport = 'Kepegawaian/IntegrasiSimpegBkn/exportPresensi/'
export const presensiketidakhadiranexport = 'Kepegawaian/IntegrasiSimpegBkn/exportketidakhadiran/'
export const presensiupdate = 'Kepegawaian/IntegrasiSimpegBkn/presensiupdate/'
export const presensiCancel = 'Kepegawaian/IntegrasiSimpegBkn/presensiCancel/'

export const masterEmployeeCategories = 'Master/List/employeeCategories/'

export const simulation = 'Kepegawaian/IntegrasiSimpegBkn/simulation/'
export const presensiExport = 'Kepegawaian/IntegrasiSimpegBkn/simulationExport/'
export const uploadpresensi = 'Kepegawaian/IntegrasiSimpegBkn/uploadpresensi/'
export const download_template_uploadpresensi = 'Kepegawaian/IntegrasiSimpegBkn/download_template_uploadpresensi/'

export const syncJabatanBkn = 'Kepegawaian/IntegrasiSimpegBkn/syncJabatanBkn/'
export const diklatList = 'Kepegawaian/IntegrasiSimpegBkn/listDiklat/'


//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}